import React from 'react';
import { KeyIcon, PackageIcon, HeadphonesIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HowToGetIt() {
  return <section id="how-to-get-it" className="w-full py-20 px-6 md:px-10 lg:px-20 bg-gradient-to-b from-[#111] to-[#111]/90" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF] mb-3" data-id="element-151">
            How To Get It
          </h2>
          <p className="text-3xl md:text-4xl font-bold" data-id="element-152">Choose Your Path</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-153">
          <div className="p-8 rounded-xl bg-[#222] border border-gray-800 flex flex-col hover:border-[#00E0FF]/30 transition-all group" data-id="element-154">
            <div className="w-14 h-14 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-6 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-155">
              <KeyIcon className="w-7 h-7 text-[#00E0FF]" data-id="element-156" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-157">Self-Serve API</h3>
            <p className="text-gray-300 mb-6 flex-grow" data-id="element-158">
              Get API keys for your dev team and start building with Critical
              Voice immediately.
            </p>
            <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" className="mt-auto" data-id="element-159">
              <Button variant="outline" className="w-full" data-id="element-160">
                Get API Keys
              </Button>
            </a>
          </div>
          <div className="p-8 rounded-xl bg-[#222] border border-[#00E0FF]/30 flex flex-col shadow-[0_0_20px_rgba(0,224,255,0.1)] relative" data-id="element-161">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#00FF9D] text-black px-3 py-1 rounded-full text-xs font-bold" data-id="element-162">
              MOST POPULAR
            </div>
            <div className="w-14 h-14 rounded-full bg-[#3F00FF]/30 flex items-center justify-center mb-6" data-id="element-163">
              <PackageIcon className="w-7 h-7 text-[#00E0FF]" data-id="element-164" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-165">Turnkey Deployment</h3>
            <p className="text-gray-300 mb-6 flex-grow" data-id="element-166">
              Full implementation of AI reps, therapists, or receptionists for
              your business.
            </p>
            <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" className="mt-auto" data-id="element-167">
              <Button className="w-full" data-id="element-168">Schedule Demo</Button>
            </a>
          </div>
          <div className="p-8 rounded-xl bg-[#222] border border-gray-800 flex flex-col hover:border-[#00E0FF]/30 transition-all group" data-id="element-169">
            <div className="w-14 h-14 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mb-6 group-hover:bg-[#3F00FF]/30 transition-all" data-id="element-170">
              <HeadphonesIcon className="w-7 h-7 text-[#00E0FF]" data-id="element-171" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-172">Enterprise Custom</h3>
            <p className="text-gray-300 mb-6 flex-grow" data-id="element-173">
              Consulting for enterprises building what's never been built
              before.
            </p>
            <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" className="mt-auto" data-id="element-174">
              <Button variant="outline" className="w-full" data-id="element-175">
                Contact Sales
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}